import PropTypes from "prop-types";
import React from "react";
import "./DashboardLight.css";

export default function DashboardLight({ isOn, status, stateName, imgSrc}) {
  const imgPath = imgSrc;
  const locking = isOn === 2 ? "locking" : "";
  const isEmergency = ["inoperable"].includes(status) ? "emergency" : "";
  const classNames = `state ${isOn ? 'on' : 'off'} ${locking} ${isEmergency} ${status}`;

  return (
    <div className={classNames}>
      <div className="frame">
        <div className="light-square">
          <img
            className="light-outline"
            alt="Alert outline"
            src={imgPath}
          />
          <div className="light-text">{stateName}</div>
        </div>
      </div>
    </div>
  );
};

DashboardLight.propTypes = {
  isOn: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  stateName: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
};
